(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reels-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".lazy-video");

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const source = video.querySelector("source");

          if (source && !source.src) {
            source.src = source.dataset.src;
            video.load();
            video.play();
          }

          observer.unobserve(video);
        }
      });
    });

    videos.forEach(video => observer.observe(video));
  } else {
    // Fallback for older browsers
    videos.forEach(video => {
      const source = video.querySelector("source");
      if (source && !source.src) {
        source.src = source.dataset.src;
        video.load();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
